import { render, staticRenderFns } from "./OrganismTabsTechnicalSpecs.vue?vue&type=template&id=3c7b8abc&scoped=true&"
import script from "./OrganismTabsTechnicalSpecs.vue?vue&type=script&lang=js&"
export * from "./OrganismTabsTechnicalSpecs.vue?vue&type=script&lang=js&"
import style0 from "./OrganismTabsTechnicalSpecs.vue?vue&type=style&index=0&id=3c7b8abc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c7b8abc",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsCommonAtomIcon: require('/app/components/atoms/common/AtomIcon.vue').default,AtomsCommonAtomTitle: require('/app/components/atoms/common/AtomTitle.vue').default,OrganismsProjectOrganismTechnicalSpecs: require('/app/components/organisms/project/OrganismTechnicalSpecs.vue').default})
